var map = {
	"./Gemini_Generated_Image_b5qfgpb5qfgpb5qf (Copy).png": 118,
	"./Gemini_Generated_Image_b5qfgpb5qfgpb5qf.png": 119,
	"./PAK-TURK-SCHOOL-LOGO-FINAL.jpg": 120,
	"./WhatsApp Image 2025-12-27 at 5.14.14 PM.jpeg": 121,
	"./WhatsApp Image 2026-02-06 at 12.53.22 AM.jpeg": 122,
	"./address_image.svg": 123,
	"./animated_ashutosh.png": 124,
	"./animated_logo.svg": 125,
	"./blogs_image.svg": 126,
	"./cloud_infrastructure.svg": 127,
	"./codeInLogo.png": 128,
	"./contactMail.png": 129,
	"./coursera_logo.png": 130,
	"./data_science.svg": 131,
	"./deeplearning_ai_logo.png": 132,
	"./delhivery_logo.png": 133,
	"./developerActivity.svg": 134,
	"./dsc_logo.png": 135,
	"./education.svg": 136,
	"./experience.svg": 137,
	"./feelingProud.svg": 138,
	"./freecopy_logo.png": 139,
	"./fullstack.svg": 140,
	"./gcp_logo.png": 141,
	"./github_logo.png": 142,
	"./googleAssistant.jpg": 143,
	"./googleAssistant.svg": 144,
	"./google_logo.png": 145,
	"./ibm_logo.png": 146,
	"./idMIXxx8N__1770238083141.jpeg": 147,
	"./iiitk_logo.png": 148,
	"./intel_logo.jpg": 149,
	"./iu_logo.png": 150,
	"./jsFramework.svg": 151,
	"./legato_logo.png": 152,
	"./manOnTable.svg": 153,
	"./microsoft_logo.png": 154,
	"./mozilla_logo.png": 155,
	"./muffito_logo.png": 156,
	"./nextuLogo.jpg": 157,
	"./nptel_logo.png": 158,
	"./pakturk.jpg": 159,
	"./portfolio.gif": 160,
	"./prime--briefcase.png": 161,
	"./programmer.svg": 162,
	"./projects_image.svg": 163,
	"./pwa.png": 164,
	"./saayaHealthLogo.png": 165,
	"./stanford_logo.png": 166,
	"./talksCardBack.svg": 167,
	"./talksCardBackAlt.svg": 168,
	"./tiktok_logo.png": 169,
	"./ui_ux_design.svg": 170,
	"./upwork.svg": 171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;